
    import './styles.scoped.css';
    export default {
  "close-button": "awsui_close-button_16w0h_1fczy_93"
};
  